import React, { useEffect, useState, useRef } from "react";
import { useId } from 'react';
import '../../Work-css/Student_portal.css';
import Student_Fee from '../Term_conditions/Student_Fee';
import School_Portal_TS from '../Term_conditions/School_Portal_TS';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import Student_image from "../Term_conditions/Student_image";
import Student_password from "../Term_conditions/Student_password";
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

function Student_portal({stude_P}) {

 const [uniq, setUnique] = useState(uuidv4())
  const [money_const, setMC] = useState(false)
  const [terms_const, setTC] = useState(false)
  const [main_const, setMAINCNS] = useState(false)
  
  
  const [studentImage, setStudentimage] = useState(false)
  const [studentpassword, setSPw] = useState(false)
  const [schoolportal, setSpt] = useState(false)
  const [studentfee, setStf] = useState(false)
  const [studentportal, setSP] = useState(true)
  const [sub, setSub] = useState(false)

  const [gender, setGender] = useState(false)
  const [genderbtn, setGenderbtn] = useState(true)
  const [name, setName] = useState()
  const [date, setDate] = useState()
  const [school, setShool] = useState()
  const [course, setCourse] = useState()
  const [ID, setID] = useState()
  const [phonenum, setPhonenum] = useState()
  const [email, setEmail] = useState()
  const [parentnum, setParentnum] = useState()
  const [checked, setChecked] = useState('')
  const [studentimg, setStudentimg] = useState()
  const [password, setPassord] = useState()
  const [dateTimeNumber, setDateTimeNumber] = useState(uuidv4());
  

  useEffect(()=>{

    if (gender && name && date && school && course && ID && phonenum && email && parentnum) {

      setSub(true)
      
    } else {
      setSub(false)
    }

  

  },[gender, name, date, school, course, ID, phonenum, email, parentnum, checked])

 

  const close = () =>
  {
    stude_P(false)
  }

  const scroll = () =>
  {
    setStudentimage(true)
    setSP(false)

            // Send data to the PHP backend using fetch
            fetch('https://hosteladventures.site/PHP/Student_portal.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
               gender: gender,
               name: name,
               date: date,
               school: school,
               course: course,
               ID: ID,
               phonenum: phonenum,
               email: email,
               parentnum: parentnum,
               checked: checked,
               unik: uniq
              })
            })
              .then(response => response.json())
              .then(data => {
                // Handle response from backend (e.g., login success or failure)
                if(data.message=='in')
                {
                  setStudentimage(true)
                  setSP(false)
                }

               
             
              })
              .catch(error => {
                console.error('Error:', error);
              });
  }

  const male = () =>{
    setGender('male')
    setGenderbtn(false)
  }

  const female = () =>{
    setGender('female')
    setGenderbtn(false)
  }

  const handleChange = (event) => {
    setChecked('checked')
  };


  return (
  <div className='outer_SP'>
  
   <div>
    {studentportal==true?(

<div className='Student_portal'>
<p className='fill_In'>Fill In</p>
    <input placeholder='name' onChange={(event) => setName(event.target.value)} />
    <div className='gender_OPT'>
      <p className='choose_gender_TT'>Choose Gender:</p>
      {genderbtn?(<div><button onClick={male}><FontAwesomeIcon icon={faPerson} /></button><button onClick={female}><FontAwesomeIcon icon={faPersonDress} /></button></div>):(<div><button><FontAwesomeIcon icon={faCheck} /></button></div>)}
    </div>
    <div>
    <div className='DOM_PH'>date of admission:</div>
    <input type='date' placeholder='date of admission' onChange={(event) => setDate(event.target.value)} />
    </div>
    <input placeholder='school' onChange={(event) => setShool(event.target.value)} />
    <input placeholder='course' onChange={(event) => setCourse(event.target.value)} />
    <input placeholder='ID Number' onChange={(event) => setID(event.target.value)} />
    <input placeholder='Phone Number/Admission number' onChange={(event) => setPhonenum(event.target.value)} />
    <input placeholder='email' onChange={(event) => setEmail(event.target.value)} />
    <input placeholder='Parent Number' onChange={(event) => setParentnum(event.target.value)} />
   
    <div className='checkBox'><div className='career_quiz'>Career Counselling? (Click check box optional)</div> 
    <div><input type="checkbox" placeholder='ggg' onChange={handleChange} /></div></div>
    {sub?(<div className='submit' onClick={scroll}>Submit</div>):('')}
   
    
    
</div>
  ):('')}

    {studentImage==true?(<div className='MPESA_SP'>
    <Student_image
   
     uniq={uniq}
     setStudentimg={setStudentimg}
     setStudentimage={setStudentimage}
     setSp = {setSP}
     setSPw={setSPw}
     gender={gender}
     name = {name}
     date = {date}
     school = {school}
     course = {course}
     ID = {ID}
     phonenum = {phonenum}
     email = {email}
     parentnum = {parentnum}
     checked ={checked}
     />
    </div>):('')}
    
    {studentpassword==true?(<div className='MPESA_SP'>
    <Student_password 
    
     
    uniq={uniq}
    setPassord={setPassord}
    setSPw = {setSPw}
    gender={gender}
    name = {name}
    date = {date}
    school = {school}
    course = {course}
    ID = {ID}
    phonenum = {phonenum}
    email = {email}
    parentnum = {parentnum}
    checked ={checked}
    /></div>):('')}
    
    {schoolportal==true?(<div className='T_C'>
    <School_Portal_TS 
    setMC={setMC} 
    stude_P={stude_P}  
    schoolportal={setSpt} 
    uniq={uniq}
    gender={gender}
    name = {name}
    date = {date}
    school = {school}
    course = {course}
    ID = {ID}
    phonenum = {phonenum}
    email = {email}
    parentnum = {parentnum}
    checked ={checked}
    /></div>):('')}
    

    
    <div className='MPESA_SP'><Student_Fee
     setTC={setTC} stude_P={stude_P}
     uniq={uniq}
     gender={gender}
     name = {name}
     date = {date}
     school = {school}
     course = {course}
     ID = {ID}
     phonenum = {phonenum}
     email = {email}
     parentnum = {parentnum}
     checked ={checked} 
     password = {password}
     studentimg = {studentimg}
     
     /></div>

    </div>
    </div>
  )
}

export default Student_portal



